import { render, staticRenderFns } from "./SecurityConfiguration.vue?vue&type=template&id=48f42d7d&scoped=true&"
import script from "./SecurityConfiguration.vue?vue&type=script&lang=ts&"
export * from "./SecurityConfiguration.vue?vue&type=script&lang=ts&"
import style0 from "./SecurityConfiguration.vue?vue&type=style&index=0&id=48f42d7d&lang=scss&scoped=true&"
import style1 from "./SecurityConfiguration.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f42d7d",
  null
  
)

export default component.exports